'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('../../themes/alert.js');
var borders = require('../../themes/borders.js');
require('../../themes/button.js');
require('../../themes/checkbox.js');
require('../../themes/divider.js');
require('../../themes/dropdown.js');
require('../../themes/fieldset.js');
var fonts = require('../../themes/fonts.js');
require('../../themes/input.js');
require('../../themes/list.js');
require('../../themes/listbox.js');
require('../../themes/loader.js');
require('../../themes/option.js');
require('../../themes/popout.js');
require('../../themes/switch.js');
require('../../themes/themes.js');
require('../../themes/tooltip.js');
var mediaQueries = require('./media-queries.js');

const baseInputStyle = styled.css`
  appearance: none;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  font-family: ${fonts.fontFamilyBook};
  font-size: 14px;
  line-height: 22px;
  min-height: 50px;
  transition:
    border-color 0.2s ease,
    color 0.2s ease;
  width: 100%;
  ${mediaQueries.mediaPrefersReducedMotion}

  &:focus {
    outline: 0;
  }

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }
`;
const afterBeforeStyle = styled.css`
  align-items: center;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  display: inline-flex;
  flex-shrink: 0;
  font-family: ${fonts.fontFamilyBook};
  font-size: 14px;
  line-height: 22px;
  min-height: 50px;
  padding: 12px 15px;
  transition:
    border-color 0.2s ease,
    color 0.2s ease,
    outline 0.1s ease;
  ${mediaQueries.mediaPrefersReducedMotion}
`;
const borderRightRadius = styled.css`
  border-bottom-left-radius: 0;
  border-bottom-right-radius: ${borders.borderRadiusLarge}px;
  border-left-width: 0;
  border-right-width: 1px;
  border-top-left-radius: 0;
  border-top-right-radius: ${borders.borderRadiusLarge}px;
`;
const borderLeftRadius = styled.css`
  border-bottom-left-radius: ${borders.borderRadiusLarge}px;
  border-bottom-right-radius: 0;
  border-left-width: 1px;
  border-right-width: 0;
  border-top-left-radius: ${borders.borderRadiusLarge}px;
  border-top-right-radius: 0;
`;
const afterStyle = styled.css`
  ${borderRightRadius}

  &[dir='rtl'] {
    ${borderLeftRadius}
  }
`;
const beforeStyle = styled.css`
  ${borderLeftRadius}

  &[dir='rtl'] {
    ${borderRightRadius}
  }
`;
/**
 * Get Styled Component shared after, before, leftIcon, and rightIcon styles
 * @param options GetInputAddonThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getInputAddonTheme = (options)=>{
    const { disabled , error , look  } = options;
    return styled.css`
    background-color: ${({ theme  })=>disabled ? theme.input[look].backgroundColorDisabled : theme.input[look].backgroundColor};
    border-color: ${({ theme  })=>disabled ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColor};
    color: ${({ theme  })=>disabled ? theme.input[look].textColorDisabled : error ? theme.input[look].textColorError : theme.input[look].textColor};
    cursor: ${disabled ? 'not-allowed' : 'default'};
  `;
};
/**
 * Get Styled Component shared after, before, leftIcon, and rightIcon styles
 * @param options GetInputAddonThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getInputAddonButtonTheme = (options)=>{
    const { disabled , error , look  } = options;
    return styled.css`
    background-color: ${({ theme  })=>disabled ? theme.input[look].backgroundColorDisabled : theme.input[look].backgroundColor};
    border-color: ${({ theme  })=>disabled ? theme.input[look].borderColorDisabled : theme.input[look].borderColor};
    color: ${({ theme  })=>disabled ? theme.input[look].textColorDisabled : theme.input[look].textColor};

    &:hover {
      border-color: ${({ theme  })=>disabled ? theme.input[look].borderColorDisabled : theme.input[look].borderColorHover};
    }

    &:focus-visible {
      border-color: ${({ theme  })=>disabled ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorFocus};
      outline-color: ${({ theme  })=>theme.input[look].outlineColorFocus};
    }

    &[aria-disabled='true'] {
      background-color: ${({ theme  })=>theme.input[look].backgroundColorDisabled};
      border-color: ${({ theme  })=>theme.input[look].borderColorDisabled};
      color: ${({ theme  })=>theme.input[look].textColorDisabled};
    }
  `;
};
/**
 * Get Styled Component input border radius
 * @param options GetInputBorderRadiusOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getInputBorderRadius = (options)=>{
    const { after , before  } = options;
    if (after && !before) {
        return styled.css`
      border-bottom-left-radius: ${borders.borderRadiusLarge}px;
      border-top-left-radius: ${borders.borderRadiusLarge}px;
    `;
    }
    if (!after && before) {
        return styled.css`
      border-bottom-right-radius: ${borders.borderRadiusLarge}px;
      border-top-right-radius: ${borders.borderRadiusLarge}px;
    `;
    }
    if (after && before) {
        return styled.css`
      border-radius: 0;
    `;
    }
    return styled.css`
    border-radius: ${borders.borderRadiusLarge}px;
  `;
};
/**
 * Get Styled Component input padding
 * @param options GetInputPaddingOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getInputPadding = (options)=>{
    const { after , before , combobox =false , leftIcon , rightIcon  } = options;
    if (after && before) {
        return styled.css`
      padding: 12px;
    `;
    }
    if (leftIcon && !rightIcon) {
        if (combobox) {
            return styled.css`
        padding: 12px 50px 12px 40px;

        [dir='rtl'] & {
          padding: 12px 40px 12px 50px;
        }
      `;
        }
        return styled.css`
      padding: 12px 15px 12px 40px;
    `;
    }
    if (!leftIcon && rightIcon) {
        return styled.css`
      padding: 12px 40px 12px 15px;
    `;
    }
    if (leftIcon && rightIcon) {
        return styled.css`
      padding: 12px 40px;
    `;
    }
    if (combobox) {
        return styled.css`
      padding: 12px 50px 12px 15px;

      [dir='rtl'] & {
        padding: 12px 15px 12px 50px;
      }
    `;
    }
    return styled.css`
    padding: 12px 15px;
  `;
};
/**
 * Get Styled Component input focused border-color
 * @param options GetInputFocusedBorderColorOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getInputFocusedBorderColor = (options)=>{
    const { disabled , error , loading , look  } = options;
    return styled.css`
    border-color: ${({ theme  })=>disabled || loading ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorFocus};
  `;
};
/**
 * Get Styled Component input focused border-color
 * @param options GetInputHoveredBorderColorOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getInputHoveredBorderColor = (options)=>{
    const { after , before , disabled , error , loading , look  } = options;
    return after && before ? styled.css`
        border-bottom-color: ${({ theme  })=>disabled || loading ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover};
        border-left-color: ${({ theme  })=>disabled || loading ? 'transparent' : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover};
        border-right-color: ${({ theme  })=>disabled || loading ? 'transparent' : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover};
        border-top-color: ${({ theme  })=>disabled || loading ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover};
      ` : styled.css`
        border-color: ${({ theme  })=>disabled || loading ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover};
      `;
};
/**
 * Get Styled Component input placeholder color
 * @param options GetInputPlaceholderColorOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getInputPlaceholderColor = (options)=>{
    const { disabled , error , loading , look  } = options;
    return styled.css`
    color: ${({ theme  })=>disabled || loading ? theme.input[look].textColorDisabled : error ? theme.input[look].textColorError : theme.input[look].textColorPlaceholder};
  `;
};
const getInputBackgroundColor = (options)=>{
    const { codeEditor , look  } = options;
    if (codeEditor) {
        return styled.css``;
    }
    return styled.css`
    background-color: ${({ theme  })=>theme.input[look].backgroundColor};
  `;
};
const getInputColor = (options)=>{
    const { codeEditor , error , look  } = options;
    if (codeEditor) {
        return styled.css``;
    }
    return styled.css`
    color: ${({ theme  })=>error ? theme.input[look].textColorError : theme.input[look].textColor};
  `;
};
/**
 * Get Styled Component input theme
 * @param options GetInputThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getInputTheme = (options)=>{
    const { after , before , codeEditor , disabled , error , look  } = options;
    const borderColor = after && before ? styled.css`
          border-bottom-color: ${({ theme  })=>error ? theme.input[look].borderColorError : theme.input[look].borderColor};
          border-left-color: ${({ theme  })=>error ? theme.input[look].borderColorError : 'transparent'};
          border-right-color: ${({ theme  })=>error ? theme.input[look].borderColorError : 'transparent'};
          border-top-color: ${({ theme  })=>error ? theme.input[look].borderColorError : theme.input[look].borderColor};
        ` : styled.css`
          border-color: ${({ theme  })=>error ? theme.input[look].borderColorError : theme.input[look].borderColor};
        `;
    const disabledBorderColor = after && before ? styled.css`
          border-bottom-color: ${({ theme  })=>theme.input[look].borderColorDisabled};
          border-left-color: transparent;
          border-right-color: transparent;
          border-top-color: ${({ theme  })=>theme.input[look].borderColorDisabled};
        ` : styled.css`
          border-color: ${({ theme  })=>theme.input[look].borderColorDisabled};
        `;
    return styled.css`
    ${getInputBackgroundColor({
        codeEditor,
        look
    })}
    ${borderColor}
    ${getInputColor({
        codeEditor,
        error,
        look
    })}

    &::placeholder {
      ${getInputPlaceholderColor({
        disabled,
        error,
        look
    })}
    }

    &:hover {
      ${getInputHoveredBorderColor({
        after,
        before,
        disabled,
        error,
        look
    })}
    }

    &:focus {
      ${getInputFocusedBorderColor({
        disabled,
        error,
        look
    })}
    }

    &[aria-disabled='true'] {
      background-color: ${({ theme  })=>theme.input[look].backgroundColorDisabled};
      ${disabledBorderColor}
      color: ${({ theme  })=>theme.input[look].textColorDisabled};
    }
  `;
};

exports.afterBeforeStyle = afterBeforeStyle;
exports.afterStyle = afterStyle;
exports.baseInputStyle = baseInputStyle;
exports.beforeStyle = beforeStyle;
exports.borderLeftRadius = borderLeftRadius;
exports.borderRightRadius = borderRightRadius;
exports.getInputAddonButtonTheme = getInputAddonButtonTheme;
exports.getInputAddonTheme = getInputAddonTheme;
exports.getInputBorderRadius = getInputBorderRadius;
exports.getInputFocusedBorderColor = getInputFocusedBorderColor;
exports.getInputHoveredBorderColor = getInputHoveredBorderColor;
exports.getInputPadding = getInputPadding;
exports.getInputPlaceholderColor = getInputPlaceholderColor;
exports.getInputTheme = getInputTheme;
//# sourceMappingURL=input.js.map
